import { GDTApiErrors } from '@/types';
import { RecommenderResp } from '@/types/recommender';
import {
  ResponseGetInitDraftTeam,
  RequestEquipoBorrador,
  ResponseArmaEquipoGrabar,
  ResponseConfirmarEquipo,
  ResponseObtenerEquipoAnterior,
  ResponseEquipoConfirmado,
} from '@/types/team';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

export const getInitBuildTeam = axiosErrorHandler(async () => {
  const url = URLs.ARMA_EQUIPO_F11.INIT;
  const response = await axiosGdt.get<ResponseGetInitDraftTeam | GDTApiErrors>(
    url
  );
  return response.data;
}, 'Error al recuperar el equipo. Reintentalo nuevamente.');

/*
const EXAMPLE_GUARDAR: RequestEquipoBorrador = {
  idTactica: 3,
  jugadores: [
    { id: 0, orden: 0, capitan: true },
    { id: -1, orden: 1 },
    { id: -2, orden: 2 },
    { id: -3, orden: 3 },
    { id: -4, orden: 4 },
    { id: -5, orden: 5 },
    { id: -6, orden: 6 },
    { id: -7, orden: 7 },
    { id: -8, orden: 8 },
    { id: -9, orden: 9 },
    { id: -10, orden: 10 },
    { id: -11, orden: 11 },
    { id: -12, orden: 12 },
    { id: -13, orden: 13 },
    { id: -14, orden: 14 },
  ],
  idUsuario: 17372900,
};
*/

export const saveTeamDraft = axiosErrorHandler(
  async (teamDraft: RequestEquipoBorrador) => {
    const url = URLs.ARMA_EQUIPO_F11.GRABAR_BORRADOR;
    const myTeam = teamDraft;
    const response = await axiosGdt.post<
      ResponseArmaEquipoGrabar | GDTApiErrors
    >(url, myTeam);
    return response.data;
  },
  TEXTS.saveTeam
);

export const saveTeamDB = axiosErrorHandler(
  async (teamDraft: RequestEquipoBorrador) => {
    const url = URLs.ARMA_EQUIPO_F11.CONFIRMAR;
    const myTeam = teamDraft;
    const response = await axiosGdt.post<
      ResponseConfirmarEquipo | GDTApiErrors
    >(url, myTeam);
    return response.data;
  },
  TEXTS.saveTeam
);

export const confirmedTeamInfo = axiosErrorHandler(async () => {
  const url = URLs.ARMA_EQUIPO_F11.EQUIPO_CONFIRMADO;
  const response = await axiosGdt.get<ResponseEquipoConfirmado | GDTApiErrors>(
    url
  );
  return response.data;
}, TEXTS.getTeamData);

export const teamLastEdition = axiosErrorHandler(async () => {
  const url = URLs.ARMA_EQUIPO_F11.EDICION_ANTERIOR;
  const response = await axiosGdt.get<
    ResponseObtenerEquipoAnterior | GDTApiErrors
  >(url);
  return response.data;
});

// Se deberia hacer un refactor de errores para este metodo usando axiosErrorHandler
export const getCriteriaRecommender = axiosErrorHandler(async () => {
  const url = URLs.ARMA_EQUIPO_F11.CRITERIOS_RECOMENDADOR;
  const response = await axiosGdt.get<RecommenderResp>(url);
  return response.data.arrayInfoCriterioTO;
}, 'Error al recuperar datos de recomendador. Reintentalo nuevamente.');
